import { render, staticRenderFns } from "./reports-tabs.vue?vue&type=template&id=0a2e1a68&scoped=true&"
import script from "./reports-tabs.vue?vue&type=script&lang=js&"
export * from "./reports-tabs.vue?vue&type=script&lang=js&"
import style0 from "./reports-tabs.vue?vue&type=style&index=0&id=0a2e1a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e1a68",
  null
  
)

export default component.exports